import { WSElement, WSText } from "@wingspanhq/fe-component-library";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryPayrollSettings } from "../../../query/payments/queries";
import { selectorFundingSourceMethodType } from "../../../shared/selectors/selectorFundingSourceMethodType";
import { LabelMethod } from "../../Settings/components/LabelMethod";
import styles from "./EmbeddedPreviewFundingMethod.module.scss";

export const EmbeddedPreviewFundingMethod = () => {
  const userId = useUserId();
  const queryPayrollSettings = useQueryPayrollSettings(userId);

  if (queryPayrollSettings.isLoading) {
    return <WSElement shimmer className={styles.shimmer} />;
  }

  const fundingSource = queryPayrollSettings.data?.fundingSource;
  const methodType = fundingSource
    ? selectorFundingSourceMethodType(fundingSource.fundingSourceType)
    : undefined;

  if (!fundingSource || !methodType) {
    return <WSText color="gray400">No funding method set</WSText>;
  }

  return <LabelMethod type={methodType} id={fundingSource.fundingSourceId} />;
};
